import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE
} from '../../themes'

export const StyleLogin = styled.div`
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%;
  width: 100%;
  color: ${COLOR.BLACK_1};
  background-color: #FFFFFF;
  .container {
    display: flex;
    width: 100%;
    height: 100%;
  }

  .bg-logo {
    width: 40%;
    height: 100%;
    max-width: 800px;
  }

  .content-logo {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .content-login {
    width: 60%;
    padding-top: 60px;
    padding-left: 80px;
    padding-right: 80px;
    padding-bottom: 20px;
  }

  .box-login {
    max-width: 540px;
    height: 100%;
  }

  .welcome-label {
    text-align: left;
    letter-spacing: 0;
    font-family: LibreBaskervilleBold;
    font-size: ${FONT_SIZE.XXXL2};
    letter-spacing: 0;
    color: ${COLOR.BLACK_1};
  }

  .welcome-label2 {
    margin-top: 8px;
    left: 0px;
    width: 511px;
    height: 37px;
    font-size: ${FONT_SIZE.SM};
    letter-spacing: 0;
    color: ${COLOR.GRAY_14};
  }

  .username-password {
    margin-top: 30px;
    max-width: 540px;
    text-align: left;
    font-size: ${FONT_SIZE.SM};
    letter-spacing: 0;
    color: ${COLOR.BLACK_4};
    opacity: 1;
  }

  .username-password-input {
    max-width: 540px;
    width: auto;
    height: 30px;
    border-radius: 5px;
    opacity: 1;
    margin-top: 10px;
    color: ${COLOR.GOLD_1};
    padding-top: 8px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 8px;
    font-size: ${FONT_SIZE.SM};
  }

  .password-part {
    display: flex;
    align-items: center;
  }

  input:focus{
    outline: none;
  }

  .password {
    margin-top: 20px;
  }

  .remember-me {
    margin-top: 30px;
    margin-bottom: 30px;
    text-align: left;

    label {
      color: ${COLOR.GRAY_14};
      font-size: ${FONT_SIZE.SM};
      opacity: 1;
      text-align: right;
      clear: both;
      vertical-align: super;
    }
    input {
      -webkit-appearance: none;
      background-color: ${COLOR.WHITE};
      border: 1px solid ${COLOR.GOLD_2};
      padding: 9px;
      border-radius: 3px;
      display: inline-block;
      position: relative;
    }
    input:active,
    input:checked:active {
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
        inset 0px 1px 3px rgba(0, 0, 0, 0.1);
    }
    input:checked {
      background-color: ${COLOR.BLACK};
      border: 1px solid #adb8c0;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
        inset 0px -16px 10px -12px rgba(0, 0, 0, 0.05),
        inset 16px 10px -12px rgba(255, 255, 255, 0.1);
    }
    input:checked:after {
      content: "✔";
      font-size: ${FONT_SIZE.TN};
      position: absolute;
      top: 0px;
      left: 3px;
      color: ${COLOR.GOLD_2};
    }
    color: ${COLOR.BLACK_1};
  }
  .bg-login {
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    height: ${window.innerHeight}px;
    width: auto;
    color: ${COLOR.GRAY_4};
  }

  .forgot {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    flex-flow: row;
    width: 100%;
    padding-top: 20px;
  }

  .forgot-link {
    font-size: ${FONT_SIZE.SM};
    color: ${COLOR.GOLD_1};
    cursor: pointer;
  }

  .sigin {
    width: 100%;
  }

  .validate {
    margin-top: 10px;
  }

  .login-with {
    display: flex;
    flex-direction: column;
    padding-top: 30px;
    gap: 30px;
  }

  .or-container {
    display: flex;
    height: 19px;
    align-items: center;
    justify-content: center;
    color: ${COLOR.GOLD_1};
    gap: 5px;

  }

  .or-text {
    font-size: ${FONT_SIZE.TN};
  }

  .line-hr {
    width: 100%;
    height: 20px;
    padding-top: 5px;
  }

  .login {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

`
